export const createContestsEditionJudgeFinalsEntriesRequests = (client) => ({
    listContestsEditionJudgeFinalsEntries: async (params) => {
        const { data } = await client.api.get("contests_edition_judge_finals_entries", {
            params: params,
        });
        return { data };
    },
    saveContestsEditionJudgeFinalsEntry: async (payload) => {
        const { data } = await client.api.create("contests_edition_judge_finals_entries", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map